<template>
  <div class="header-back">
    <span class="header-back-btn" role="button" @click="group1.historyBack"><FontawesomeIcon :icon="['far','angle-left']" size="lg" /></span>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'

export default defineComponent({
  name: 'PCButtonHistoryBack',
  props: {
    action: {
      type: Function,
      default: null
    }
  },
  setup (props, context) {

    const group1 = reactive({
      historyBack: () => {
        // 現在の画面名(/router/index.jsのrouter.beforeEach()メソッド内でストアに保存された値)
        const toName = store.state.common.toName
        if (toName === 'PCQADetailPreview') {
          // 書籍プレビューの場合は遷移しない
          return
        }

        if (props.action) {
          props.action()
        } else {
          router.go(-1)
        }
      }
    })
   
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.header-back {
  cursor: pointer;
}
</style>
